import React, { ReactChild } from "react";
import styled from "styled-components";
import { CommonButtonStyled } from "./common-styled";

interface Props {
  onClick: () => void;
  children: ReactChild;
}

const FilledButton = ({ onClick, children }: Props) => {
  return <Button onClick={onClick}>{children}</Button>;
};

export default FilledButton;

const Button = styled(CommonButtonStyled)`
  font-size: 24px;
`;
